import { Permission } from "./Permission";

export enum RoleName {
  super_admin = "super_admin",
  admin = "admin",
  user = "user",
  ppl_dispute_admin = "ppl_dispute_admin",
  ppl_marketing_team = "ppl_marketing_team",
}

export interface Role {
  id: number;
  name: RoleName;
  description: string;
  permissions: Permission[];

  created_at: Date;
  updated_at: Date;
  created_by: string;
  updated_by: string;
}
